export default __webpack_public_path__ + "static/media/zuuteils.dfde7a31.png";